/* eslint-disable */

/**
 * 
 * 
 * This component is auto-generated, please don't touch it!
 * 
 * 
 */

import * as React from "react";

function Nf(props) {
  return <svg width="1em" height="1em" viewBox="0 0 512 336" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none"><path d="M170.667 335.724H8.828A8.829 8.829 0 0 1 0 326.896V9.104A8.829 8.829 0 0 1 8.828.276h161.839v335.448z" fill="#73AF00" /><path fill="#F5F5F5" d="M170.67.276h170.67v335.448H170.67z" /><path d="M503.172 335.724H341.333V.276h161.839A8.829 8.829 0 0 1 512 9.104v317.792a8.828 8.828 0 0 1-8.828 8.828zm-188.213-81.126L287.563 94.786a49.976 49.976 0 0 0-6.402-17.266L256 35.586l-25.161 41.935a49.956 49.956 0 0 0-6.402 17.266L197.04 254.6a4.997 4.997 0 0 0 4.925 5.841h44.041v39.973h19.987V260.44h44.041a4.997 4.997 0 0 0 4.925-5.842z" fill="#73AF00" /></g></svg>;
}

export default Nf;